import React, { useMemo } from 'react';
import { Spin } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { normalizeFeishuUrl, splitFeishuSegments } from '@/utils/feishuLink';

interface FeishuRichTextProps {
  content?: string | null;
  /** 归一化飞书 URL -> 文档标题 */
  titles: Record<string, string>;
  /** 是否仍有标题在解析中 */
  loading?: boolean;
  /** 透传给容器，调用方传入原有样式类（含 whitespace-pre-wrap） */
  className?: string;
}

/**
 * 渲染可能内嵌飞书文档链接的纯文本：链接替换为文档标题并可点击跳转，
 * 标题未解析出来时回退显示原始链接。
 */
export const FeishuRichText: React.FC<FeishuRichTextProps> = ({
  content,
  titles,
  loading,
  className,
}) => {
  const segments = useMemo(() => splitFeishuSegments(content ?? ''), [content]);

  return (
    <div className={className}>
      {segments.map((seg, i) => {
        if (seg.type === 'text') {
          return <React.Fragment key={`t-${i}`}>{seg.value}</React.Fragment>;
        }
        const title = titles[normalizeFeishuUrl(seg.value)];
        return (
          <a
            key={`l-${i}`}
            href={seg.value}
            target="_blank"
            rel="noopener noreferrer"
            title={seg.value}
            style={{ color: '#1890ff' }}
          >
            <LinkOutlined style={{ fontSize: 12, marginRight: 4 }} />
            {title ?? seg.value}
            {loading && !title && <Spin size="small" style={{ marginLeft: 4 }} />}
          </a>
        );
      })}
    </div>
  );
};
